import { gql } from '@apollo/client'

export const DELETE_PAYMENT_METHOD = gql`
  mutation DeleteUserPaymentMethod($stripeId: String!) {
    deleteUserPaymentMethod(stripeId: $stripeId)
  }
`
